import { connect } from 'react-redux'
import NeighborhoodView from './PageNeighborhoods.component'
import { loadNewsBySector, loadImisBySector } from '../../actions/residential'
import { setPhone } from '../../actions/header'
import { TEL_NEIGHBORHOODS } from '../../constants/phones'

const mapStateToProps = (state) => {
  return {
    newsList: state.residential.news,
    imis: state.residential.imis
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    didMount: () => {
      dispatch(setPhone(TEL_NEIGHBORHOODS))
      dispatch(loadImisBySector(6))
      dispatch(loadNewsBySector(6))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NeighborhoodView)



// WEBPACK FOOTER //
// ./src/features/PageNeighborhoods/PageNeighborhoods.container.js